import * as i0 from '@angular/core';
import { Injectable, Component, ChangeDetectionStrategy, Input, NgModule } from '@angular/core';
import { map } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import * as i1$1 from '@angular/forms';
import { FormGroup, FormArray, ControlContainer, FormGroupDirective, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs';
import { getSubTaskDetails } from 'visa-store';
import * as i2 from '@angular/router';
import * as i4 from '@ngrx/store';
import * as i5 from 'app-services-library';
import * as i6 from '@angular/common';
import * as i7 from 'primeng/checkbox';
import { PrimengLibraryModule } from 'primeng-library';

class VdAddGenerateFormService {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    getFormTypes(payload) {
        return this.httpClient.post(`/vd/forms`, payload).pipe(map((response) => {
            return response;
        }));
    }
}
VdAddGenerateFormService.ɵfac = function VdAddGenerateFormService_Factory(t) { return new (t || VdAddGenerateFormService)(i0.ɵɵinject(i1.HttpClient)); };
VdAddGenerateFormService.ɵprov = i0.ɵɵdefineInjectable({ token: VdAddGenerateFormService, factory: VdAddGenerateFormService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VdAddGenerateFormService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

function VdAddGenerateFormComponent_div_9_ng_container_14_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 15);
    i0.ɵɵelementStart(2, "div", 16);
    i0.ɵɵelementStart(3, "input", 17);
    i0.ɵɵlistener("change", function VdAddGenerateFormComponent_div_9_ng_container_14_Template_input_change_3_listener() { i0.ɵɵrestoreView(_r7); const x_r4 = ctx.$implicit; const i_r5 = ctx.index; const ctx_r6 = i0.ɵɵnextContext(2); return ctx_r6.handleDependentChange(x_r4, i_r5); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "label", 18);
    i0.ɵɵelementStart(5, "span", 3);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const x_r4 = ctx.$implicit;
    const i_r5 = ctx.index;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formGroupName", i_r5);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", x_r4.displayName);
    i0.ɵɵattribute("disabled", x_r4.isDisabled ? true : null);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(x_r4.displayName);
} }
function VdAddGenerateFormComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelementStart(1, "div", 7);
    i0.ɵɵelementStart(2, "div", 8);
    i0.ɵɵelementStart(3, "p-checkbox", 9);
    i0.ɵɵlistener("onChange", function VdAddGenerateFormComponent_div_9_Template_p_checkbox_onChange_3_listener() { i0.ɵɵrestoreView(_r9); const item_r1 = ctx.$implicit; const i_r2 = ctx.index; const ctx_r8 = i0.ɵɵnextContext(); return ctx_r8.handleFormTypeChange(item_r1, i_r2); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "label", 10);
    i0.ɵɵelementStart(5, "span", 3);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div");
    i0.ɵɵelementStart(8, "label", 11);
    i0.ɵɵelementStart(9, "span", 3);
    i0.ɵɵtext(10, "Generate form for");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 12);
    i0.ɵɵelementStart(12, "div");
    i0.ɵɵelementStart(13, "div", 13);
    i0.ɵɵtemplate(14, VdAddGenerateFormComponent_div_9_ng_container_14_Template, 7, 4, "ng-container", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ctx.$implicit;
    const i_r2 = ctx.index;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formGroupName", i_r2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", item_r1.formTypeDisplayName);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("Form ", item_r1.formTypeDisplayName, "");
    i0.ɵɵadvance(8);
    i0.ɵɵproperty("ngForOf", item_r1.generateFormFor);
} }
class VdAddGenerateFormComponent {
    constructor(fb, router, parentFor, vdAddGenerateFormService, store, appServicesLibraryService, cdr) {
        this.fb = fb;
        this.router = router;
        this.parentFor = parentFor;
        this.vdAddGenerateFormService = vdAddGenerateFormService;
        this.store = store;
        this.appServicesLibraryService = appServicesLibraryService;
        this.cdr = cdr;
        this.group = new FormGroup({});
        this.showEADContentSection = false;
        this.dependentList = [];
        this.formTypeList = [];
        this.observableSubscription$ = new Subject();
        this.formTypeArray = [];
    }
    ngOnInit() {
        this.userType = sessionStorage.getItem('userTypeRole');
        this.store.select(getSubTaskDetails)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((data) => {
            //  console.log("this.subTaskDetails",data);
            if (data.id) {
                this.subTaskDetails = data;
            }
        });
        // this.getAllFormTypes();
        const jsonInput = this.inputData && this.inputData.jsonInput ? this.inputData.jsonInput : null;
        if (jsonInput) {
            if (jsonInput.applicantsList && jsonInput.applicantsList.length > 0) {
                this.dependentList = jsonInput.applicantsList.map(x => {
                    return Object.assign(Object.assign({}, x), { displayName: `${x.firstName} ${x.lastName} - ${x.relationshipName}`, isChecked: false, isDisabled: true });
                });
            }
            else {
                if (jsonInput === null || jsonInput === void 0 ? void 0 : jsonInput.primaryApplicant) {
                    const primaryApplicantObj = Object.assign(Object.assign({}, jsonInput === null || jsonInput === void 0 ? void 0 : jsonInput.primaryApplicant), { displayName: `${jsonInput === null || jsonInput === void 0 ? void 0 : jsonInput.primaryApplicant.firstName} ${jsonInput === null || jsonInput === void 0 ? void 0 : jsonInput.primaryApplicant.lastName} - ${jsonInput === null || jsonInput === void 0 ? void 0 : jsonInput.primaryApplicant.relationshipName}`, isChecked: false });
                    this.dependentList.push(primaryApplicantObj);
                }
            }
        }
        if (this.inputParams.properties.formIncludeBeneficiary && this.subTaskDetails && this.subTaskDetails.beneficiaryDetails) {
            const beneficiaryObj = {
                displayName: `${this.subTaskDetails.beneficiaryDetails.firstName} ${this.subTaskDetails.beneficiaryDetails.lastName}`,
                id: this.subTaskDetails.beneficiaryDetails.id,
                isChecked: false,
                firstName: this.subTaskDetails.beneficiaryDetails.firstName,
                lastName: this.subTaskDetails.beneficiaryDetails.lastName,
                isDisabled: true
            };
            this.dependentList.push(beneficiaryObj);
        }
        let formTypeArray;
        if (this.inputParams.value && this.inputParams.value.formTypeArray && this.inputParams.value.formTypeArray.length > 0) {
            formTypeArray = this.inputParams.value.formTypeArray;
            formTypeArray.forEach(item => {
                if (item.generateFormFor.length !== this.dependentList.length && item.generateFormFor.length < this.dependentList.length) {
                    const notExistInArray = this.dependentList.filter(obj1 => {
                        return !item.generateFormFor.some((obj2) => {
                            return obj1.firstName === obj2.firstName;
                        });
                    });
                    if ((notExistInArray === null || notExistInArray === void 0 ? void 0 : notExistInArray.length) > 0) {
                        item.generateFormFor = item.generateFormFor.concat(notExistInArray);
                    }
                }
                else if (item.generateFormFor.length !== this.dependentList.length && item.generateFormFor.length > this.dependentList.length) {
                    const notExistInArray = item.generateFormFor.filter(obj1 => {
                        return !this.dependentList.some((obj2) => {
                            return obj1.firstName === obj2.firstName;
                        });
                    });
                    if ((notExistInArray === null || notExistInArray === void 0 ? void 0 : notExistInArray.length) > 0) {
                        item.generateFormFor = item.generateFormFor.filter(ar => !notExistInArray.find(rm => (rm.firstName === ar.firstName)));
                    }
                }
            });
        }
        else {
            // this.formTypeArray = [{ formType: 'I129',isFormTypeChecked:true, formTypeDisplayName: 'I-129', generateFormFor: [] }, { formType: 'I485', isFormTypeChecked:true,formTypeDisplayName: 'I-485', generateFormFor: [] }]
            formTypeArray = this.inputParams.properties && this.inputParams.properties.formTypeArray ? this.inputParams.properties.formTypeArray : [];
            formTypeArray = formTypeArray.map(x => {
                return Object.assign(Object.assign({}, x), { generateFormFor: this.dependentList });
            });
        }
        formTypeArray.forEach(item => {
            item.generateFormFor = item.generateFormFor.map(y => {
                return Object.assign(Object.assign({}, y), { displayName: y.displayName ? y.displayName : y.relationshipName ? `${y.firstName} ${y.lastName} - ${y.relationshipName}` : `${y.firstName} ${y.lastName}`, isDisabled: item.isFormTypeChecked ? false : true });
            });
        });
        this.formTypeArray = formTypeArray;
        // console.log("this.formTypeArray", this.formTypeArray);
        // this.formTypeArray = formTypeArray.filter(x => x.formTypeDisplayName !== 'I-131' || (x.formTypeDisplayName === 'I-131' && !['IR2', 'IR5'].includes(this.inputData.immClassificationCode)));  // need to uncomment for production
        let fromGrpName = Object.assign(this.groupName);
        let primaryApplicantId;
        primaryApplicantId = this.dependentList.find(item => item.isPrimaryApplicant) ? (this.dependentList.find(item => item.isPrimaryApplicant)).id : null;
        this.group.addControl(fromGrpName, new FormGroup({
            formTypeArray: this.fb.array([]),
        }));
        this.addFormTypeControl();
        if (this.inputData) {
            this.toggleInputFields();
        }
    }
    getFormTypeArrays() {
        let fromGrpName = Object.assign(this.groupName);
        return this.group.controls[fromGrpName].get('formTypeArray').controls;
        //return (this.jobDescriptionForm.controls['address'] as FormArray).controls;
        //return (this.group.controls['formTypeArray'] as FormArray).controls;
    }
    getAllFormTypes() {
        const payload = {
            "petitionType": "",
            "taskTypeRef": "",
            "visaType": ""
        };
        this.vdAddGenerateFormService.getFormTypes(payload)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            this.formTypeList = Object.assign([], response.data);
        });
    }
    toggleInputFields() {
        // console.log(this.inputData.stepStatusCode)
        if (this.appServicesLibraryService.fieldToBeDisabled(this.inputData.stepStatusCode)) {
            this.group.disable();
        }
        else {
            this.group.enable();
        }
    }
    addFormTypeControl() {
        //  const formTypeArray = this.group.get('generate_form.formTypeArray') as FormArray;
        let fromGrpName = Object.assign(this.groupName);
        const formTypeArray = this.group.controls[fromGrpName].get('formTypeArray');
        formTypeArray.clear();
        if (this.formTypeArray && this.formTypeArray.length > 0) {
            this.formTypeArray.forEach((x) => {
                const formGroup = this.createFormTypeGroup(x);
                formTypeArray.push(formGroup);
            });
        }
    }
    createFormTypeGroup(item) {
        return this.fb.group({
            formType: item.formType,
            isFormTypeChecked: item.isFormTypeChecked,
            formTypeDisplayName: item.formTypeDisplayName,
            generateFormFor: this.addFilingThisFormControl(item),
        });
    }
    addFilingThisFormControl(item) {
        const initiateArray = new FormArray([]);
        initiateArray.clear();
        if (item.generateFormFor && item.generateFormFor.length > 0) {
            item.generateFormFor.forEach((x) => {
                const formGroup = this.createApplicantList(x);
                initiateArray.push(formGroup);
            });
        }
        else {
            if (this.dependentList && this.dependentList.length > 0) {
                this.dependentList.forEach((x) => {
                    const formGroup = this.createApplicantList(x);
                    initiateArray.push(formGroup);
                });
            }
        }
        return initiateArray;
    }
    handleFormTypeChange(item, index) {
        //   console.log(item, index, this.formTypeArray[index]['generateFormFor']);
        let fromGrpName = Object.assign(this.groupName);
        const formTypeArray = this.group.controls[fromGrpName].get('formTypeArray');
        let temp = formTypeArray.controls[index].get('generateFormFor');
        this.formTypeArray[index]['generateFormFor'] = this.formTypeArray[index]['generateFormFor'].map((item) => {
            return Object.assign(Object.assign({}, item), { isDisabled: formTypeArray.controls[index].get('isFormTypeChecked').value ? false : true });
        });
        if (!formTypeArray.controls[index].get('isFormTypeChecked').value) {
            temp.controls.forEach((x) => {
                x.patchValue({
                    isChecked: false
                });
            });
        }
    }
    createApplicantList(item) {
        return this.fb.group({
            id: item.id,
            firstName: item.firstName,
            lastName: item.lastName,
            middleName: item.middleName,
            relationshipName: item.relationshipName,
            relationshipCode: item.relationshipCode,
            isChecked: item.isChecked,
            isPrimaryApplicant: item.isPrimaryApplicant,
            isDisabled: item.isDisabled,
            displayName: item.displayName ? item.displayName : `${item.firstName} ${item.lastName} - ${item.relationshipName}`
        });
    }
    ngOnChanges() {
        // console.log('child Label', this.sublabel);
        // this.subText =  this.sublabel;
    }
    handleChange($event) {
        // console.log("$event", $event);
        this.showEADContentSection = $event.checked;
        //this.disableFormControl()
    }
    handleDependentChange(dependent, index) {
        // console.log(dependent, index);
    }
    ngAfterViewInit() {
        this.appServicesLibraryService.reportLoaded();
    }
}
VdAddGenerateFormComponent.ɵfac = function VdAddGenerateFormComponent_Factory(t) { return new (t || VdAddGenerateFormComponent)(i0.ɵɵdirectiveInject(i1$1.FormBuilder), i0.ɵɵdirectiveInject(i2.Router), i0.ɵɵdirectiveInject(i1$1.FormGroupDirective), i0.ɵɵdirectiveInject(VdAddGenerateFormService), i0.ɵɵdirectiveInject(i4.Store), i0.ɵɵdirectiveInject(i5.AppServicesLibraryService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
VdAddGenerateFormComponent.ɵcmp = i0.ɵɵdefineComponent({ type: VdAddGenerateFormComponent, selectors: [["vd-add-generate-form"]], inputs: { validation: "validation", readonly: "readonly", sublabel: "sublabel", groupElementProperty: "groupElementProperty", groupName: "groupName", group: "group", inputParams: "inputParams", inputData: "inputData" }, features: [i0.ɵɵProvidersFeature([], [
            { provide: ControlContainer, useExisting: FormGroupDirective },
        ]), i0.ɵɵNgOnChangesFeature], decls: 10, vars: 3, consts: [[2, "width", "600px", 3, "formGroup"], [1, "text-field", 3, "formGroupName"], [1, "row", "mt-2"], [1, "common-bene-class-for-translation"], ["formArrayName", "formTypeArray", 1, "ml-3"], ["class", "mb-1", 4, "ngFor", "ngForOf"], [1, "mb-1"], [3, "formGroupName"], [1, "row"], ["styleClass", "checkbox-label-allign", "formControlName", "isFormTypeChecked", "binary", "true", 3, "name", "onChange"], [1, "checkBoxLabel"], [1, "create-task-label", "required"], ["formArrayName", "generateFormFor"], [1, "row", "mt-2", 2, "display", "block"], [4, "ngFor", "ngForOf"], [2, "display", "inline-block", 3, "formGroupName"], [1, "pl-2"], ["formControlName", "isChecked", "type", "checkbox", "value", "x.isChecked", 1, "checkBoxList1", 3, "name", "change"], [1, "radioLabel"]], template: function VdAddGenerateFormComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div");
        i0.ɵɵelementStart(4, "label");
        i0.ɵɵelementStart(5, "h6");
        i0.ɵɵelementStart(6, "span", 3);
        i0.ɵɵtext(7, "Do you also want to generate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 4);
        i0.ɵɵtemplate(9, VdAddGenerateFormComponent_div_9_Template, 15, 4, "div", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("formGroup", ctx.group);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("formGroupName", ctx.groupName);
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("ngForOf", ctx.formTypeArray);
    } }, directives: [i1$1.NgControlStatusGroup, i1$1.FormGroupDirective, i1$1.FormGroupName, i1$1.FormArrayName, i6.NgForOf, i7.Checkbox, i1$1.NgControlStatus, i1$1.FormControlName, i1$1.CheckboxControlValueAccessor], styles: [".checkBoxLabel[_ngcontent-%COMP%]{margin-top:10px;margin-left:5px;font-weight:600}.borderBottom1px[_ngcontent-%COMP%]{border-bottom:1px solid #ccc}.smallWarningFont[_ngcontent-%COMP%]{font-size:12px;font-style:italic}.checkBoxList1[_ngcontent-%COMP%]{height:18px;width:18px;min-height:15px;min-width:15px;vertical-align:text-bottom;margin-top:5px;position:absolute}.radioLabel[_ngcontent-%COMP%]{top:6px;margin-left:30px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VdAddGenerateFormComponent, [{
        type: Component,
        args: [{
                selector: 'vd-add-generate-form',
                templateUrl: 'vd-add-generate-form.component.html',
                styleUrls: ['vd-add-generate-form.component.scss'],
                viewProviders: [
                    { provide: ControlContainer, useExisting: FormGroupDirective },
                ],
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: i1$1.FormBuilder }, { type: i2.Router }, { type: i1$1.FormGroupDirective }, { type: VdAddGenerateFormService }, { type: i4.Store }, { type: i5.AppServicesLibraryService }, { type: i0.ChangeDetectorRef }]; }, { validation: [{
            type: Input
        }], readonly: [{
            type: Input
        }], sublabel: [{
            type: Input
        }], groupElementProperty: [{
            type: Input
        }], groupName: [{
            type: Input
        }], group: [{
            type: Input
        }], inputParams: [{
            type: Input
        }], inputData: [{
            type: Input
        }] }); })();

class VdAddGenerateFormModule {
}
VdAddGenerateFormModule.ɵfac = function VdAddGenerateFormModule_Factory(t) { return new (t || VdAddGenerateFormModule)(); };
VdAddGenerateFormModule.ɵmod = i0.ɵɵdefineNgModule({ type: VdAddGenerateFormModule });
VdAddGenerateFormModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            FormsModule,
            ReactiveFormsModule,
            PrimengLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(VdAddGenerateFormModule, { declarations: [VdAddGenerateFormComponent], imports: [FormsModule,
        ReactiveFormsModule,
        PrimengLibraryModule], exports: [VdAddGenerateFormComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VdAddGenerateFormModule, [{
        type: NgModule,
        args: [{
                declarations: [VdAddGenerateFormComponent],
                imports: [
                    FormsModule,
                    ReactiveFormsModule,
                    PrimengLibraryModule
                ],
                exports: [VdAddGenerateFormComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of vd-add-generate-form
 */

/**
 * Generated bundle index. Do not edit.
 */

export { VdAddGenerateFormComponent, VdAddGenerateFormModule, VdAddGenerateFormService };
//# sourceMappingURL=vd-add-generate-form.js.map
